import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import Checkbox from '../Atoms/Checkbox';

const propTypes = exact({
  handleCheckboxChange: PropTypes.func.isRequired,
  signUpAccepted1: PropTypes.bool,
  signUpAccepted2: PropTypes.bool,
  signUpAccepted3: PropTypes.bool,
  signUpAccepted4: PropTypes.bool,
  signUpLabelText1: PropTypes.string,
  signUpLabelText2: PropTypes.string,
  signUpLabelText3: PropTypes.string,
  signUpLabelText4: PropTypes.string,
  termsConditionsAccepted: PropTypes.bool,
  termsConditionsLabelText: PropTypes.string,
  termsConditionsText: PropTypes.string,
  title: PropTypes.string,
});

const defaultProps = {
  signUpAccepted1: false,
  signUpAccepted2: false,
  signUpAccepted3: false,
  signUpAccepted4: false,
  signUpLabelText1: null,
  signUpLabelText2: null,
  signUpLabelText3: null,
  signUpLabelText4: null,
  termsConditionsAccepted: false,
  termsConditionsLabelText: 'I accept the legal requirements',
  termsConditionsText: null,
  title: 'Terms & Conditions',
};

function TermsConditions(props) {
  return (
    <fieldset className="TermsConditions">
      <div className="TermsConditions_content">
        <h2 className="TermsConditions_title">{props.title}</h2>
        {props.termsConditionsText && (
          <div
            className="TermsConditions_body"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: props.termsConditionsText }}
          />
        )}
        <div className="TermsConditions_cta">
          <Checkbox
            blockName="TermsConditions_checkbox"
            fieldID="termsConditionsAccepted"
            fieldName="termsConditionsAccepted"
            fieldValue="true"
            handleChange={props.handleCheckboxChange}
            inputType="checkbox"
            isChecked={props.termsConditionsAccepted}
            modifier="ghost"
            text={props.termsConditionsLabelText}
          />
          {props.signUpLabelText1 && (
            <Checkbox
              blockName="TermsConditions_checkbox"
              fieldID="marketingSignUp1"
              fieldName="marketingSignUp1"
              fieldValue="true"
              handleChange={props.handleCheckboxChange}
              inputType="checkbox"
              isChecked={props.signUpAccepted1}
              modifier="ghost"
              text={props.signUpLabelText1}
            />
          )}
          {props.signUpLabelText2 && (
            <Checkbox
              blockName="TermsConditions_checkbox"
              fieldID="marketingSignUp2"
              fieldName="marketingSignUp2"
              fieldValue="true"
              handleChange={props.handleCheckboxChange}
              inputType="checkbox"
              isChecked={props.signUpAccepted2}
              modifier="ghost"
              text={props.signUpLabelText2}
            />
          )}
          {props.signUpLabelText3 && (
            <Checkbox
              blockName="TermsConditions_checkbox"
              fieldID="marketingSignUp3"
              fieldName="marketingSignUp3"
              fieldValue="true"
              handleChange={props.handleCheckboxChange}
              inputType="checkbox"
              isChecked={props.signUpAccepted3}
              modifier="ghost"
              text={props.signUpLabelText3}
            />
          )}
          {props.signUpLabelText4 && (
            <Checkbox
              blockName="TermsConditions_checkbox"
              fieldID="marketingSignUp4"
              fieldName="marketingSignUp4"
              fieldValue="true"
              handleChange={props.handleCheckboxChange}
              inputType="checkbox"
              isChecked={props.signUpAccepted4}
              modifier="ghost"
              text={props.signUpLabelText4}
            />
          )}
        </div>
      </div>
    </fieldset>
  );
}

TermsConditions.propTypes = propTypes;
TermsConditions.defaultProps = defaultProps;

export default TermsConditions;
